import React, { FC } from 'react';
import { ArrayInput, useTranslate, SimpleFormIterator, TextInput } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';

interface ServiceChargeFormProps {
  keyName: string;
}
export const ServiceChargeForm: FC<ServiceChargeFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <ArrayInput source={`${keyName}.items`} label='' className={classes.simpleArrayInput}>
      <SimpleFormIterator>
        <TextInput label={t('serviceChargeSubtype')} source='id' />
      </SimpleFormIterator>
    </ArrayInput>
  );
};
